export function formatFormResultDate(value) {
	const date = value?.toDate?.() || (value?.seconds ? new Date(value.seconds * 1000) : value ? new Date(value) : null)
	return date && !Number.isNaN(date.getTime()) ? date.toLocaleDateString() : ""
}

export function getFormResultConfig(config, result = {}) {
	return config ?? result.enginePayload?.form ?? result.summary?.form ?? {}
}

export function getFormResultAnswers(result = {}) {
	return result.enginePayload?.answers ?? result.summary?.answers ?? {}
}

export function getFormResultDate(result = {}, key) {
	const recorded = result.enginePayload?.[key] || result.summary?.[key]
	const raw = result.createdAt
	const date = raw?.toDate?.() || (raw?.seconds !== undefined ? new Date(raw.seconds * 1000) : raw ? new Date(raw) : null)
	return recorded || (date && !Number.isNaN(date.getTime()) ? date.toISOString().slice(0, 10) : "")
}

export function getStoredFormAnswerLabel(options = [], value, previousOptions = [], emptyLabel = "Unanswered") {
	if (value === undefined || value === null || value === "") return emptyLabel
	const current = options.find(option => (option.id ?? option.value) === value)
	if (current) return current.value === undefined ? current.title : `${current.value} ${current.title}`
	const previous = previousOptions.find(option => (option.id ?? option.value) === value)
	return `${previous?.title || value} (removed choice)`
}

export function getAnchoredFormRatingReview(result = {}, priorResults = [], fallbackConfig) {
	const effectiveConfig = getFormResultConfig(fallbackConfig, result)
	const focus = String(getFormResultConfig(undefined, result).focus ?? effectiveConfig.focus ?? "").trim()
	const field = (effectiveConfig.fields || []).find(item => item.id === effectiveConfig.ratingFieldId && item.type === "SCALE")
	const reasonField = (effectiveConfig.fields || []).find(item => item.id === effectiveConfig.reasonFieldId)
	const answers = getFormResultAnswers(result)
	const rating = field && answers[field.id] !== null && answers[field.id] !== undefined && answers[field.id] !== "" ? Number(answers[field.id]) : null
	const reason = reasonField ? String(answers[reasonField.id] ?? "") : ""
	const fields = effectiveConfig.fields || []
	const hasAnswer = fields.some(item => answers[item.id] !== null && answers[item.id] !== undefined && String(answers[item.id]).trim() !== "")
	const isComplete = fields.length > 0 && hasAnswer && fields.filter(item => item.isRequired).every(item => answers[item.id] !== null && answers[item.id] !== undefined && String(answers[item.id]).trim() !== "")
	const currentDate = getFormResultDate(result)
	const comparable = (priorResults || []).filter(prior => {
		const priorConfig = getFormResultConfig(undefined, prior)
		const priorAnswers = getFormResultAnswers(prior)
		return prior.id !== result.id && prior.toolType === result.toolType && String(priorConfig.focus || "").trim() === focus && focus && priorConfig.ratingFieldId && priorAnswers[priorConfig.ratingFieldId] !== null && priorAnswers[priorConfig.ratingFieldId] !== undefined && priorAnswers[priorConfig.ratingFieldId] !== ""
	}).map(prior => {
		const priorConfig = getFormResultConfig(undefined, prior)
		return {id: prior.id, date: getFormResultDate(prior), rating: Number(getFormResultAnswers(prior)[priorConfig.ratingFieldId]), max: Number((priorConfig.fields || []).find(item => item.id === priorConfig.ratingFieldId)?.max || priorConfig.ratingScaleMax || 10)}
	}).filter(row => Number.isFinite(row.rating) && (!currentDate || row.date <= currentDate)).sort((a, b) => a.date.localeCompare(b.date))
	const previous = comparable.at(-1) || null
	const archivedItems = getNarrativeFormResultView(effectiveConfig, result).archivedItems
	return {config: effectiveConfig, archivedItems, field, reasonField, rating, reason, isComplete, date: currentDate, priorResults: comparable, difference: rating === null || !previous ? null : rating - previous.rating}
}


function createNarrativeResultRow(config, result, normalizeConfig) {
	const current = normalizeConfig(JSON.parse(JSON.stringify(getFormResultConfig(config, result))))
	const answers = JSON.parse(JSON.stringify(getFormResultAnswers(result)))
	const snapshot = getFormResultConfig(undefined, result)
	const activeIds = new Set((current.fields || []).map(field => field.id))
	const previousFields = new Map([
		...(current.archivedFields || []), ...(snapshot.archivedFields || []), ...(snapshot.fields ?? snapshot.formElements ?? []),
	].map(field => [field.id, field]))
	const archivedItems = Object.entries(answers)
		.filter(([id, answer]) => !activeIds.has(id) && answer !== undefined && answer !== null && answer !== "" && (!Array.isArray(answer) || answer.length > 0))
		.map(([id, answer]) => ({id, title: previousFields.get(id)?.title || id, answer}))
	return {id: result.id, createdAt: result.createdAt, config: current, answers, archivedItems}
}

export function getNarrativeFormResultView(config, result = {}, priorResults = [], normalizeConfig = value => value) {
	const view = createNarrativeResultRow(config, result, normalizeConfig)
	const previous = priorResults.filter(prior => (!result.id || prior.id !== result.id) && prior.toolType === result.toolType)
	return {...view, priorResults: previous.map(prior => createNarrativeResultRow(config, prior, normalizeConfig))}
}
